import React from "react";
import { Link } from "react-router-dom";
import { useAppState } from "./RetailerFitGuide_StateContext.jsx";
import Notification from '/Foundation/Common/code/Views/Foundation/Common/Notifications/Notification';

export const RetailerFitGuide_Header = () => {
    const {
        productList,
        notificationMessage,
        setNotificationMessage
    } = useAppState();

    const count = productList?.reduce((total, obj) => total + (obj.Quantity || 0), 0);

    return <div className="retailerFitGuide_Header">
        <div className="layout__content">
            <div className="thule-container">
                <nav className="retailerFitGuide_HeaderContent">
                    <Link to="/" className="logotype-link">
                        <i className='logotype'></i>
                        <span className="sr-only">Home</span>
                    </Link>
                    <ul className="retailerFitGuide_HeaderContentButtons">
                        <li>
                            <Link to={`productlist`}><button className="btn">
                                <i className="le-icon-bookmark" />
                                <span className="sr-only">Product list</span>
                            </button></Link>
                            {count > 0 && <span className="productList__count">{count}</span>}

                        </li>
                        <li>
                            <Link to={`/`}> <span className="sr-only">Home</span>
                                <i className="le-icon-home" />
                                <span className="sr-only">Home</span>
                            </Link>
                        </li>
                    </ul>
                </nav>
                {notificationMessage && <Notification
                    Type={'success'}
                    Size={'sm'}
                    Message={notificationMessage + "!"}
                    ShowIcon={true}
                    CloseAction={() => setNotificationMessage(null)}
                    IsToast={true}
                />}
            </div>
        </div>
    </div>
}